module.exports = __webpack_public_path__ + "03_glasses_black.bf1ede4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/03_glasses_black.png
// module id = Dmgh
// module chunks = 0